var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.index == 2
      ? 'rank-top-card-left'
      : _vm.index == 1
      ? 'rank-top-card-center'
      : 'rank-top-card-right'},[_c('div',{staticClass:"rank-top-card-content"},[_c('img',{attrs:{"src":_vm.OSS_BASE + '/market/img/rank/00' + _vm.index + '.png'}}),_vm._v(" "),_c('div',{staticClass:"rank-top-time"},[_vm._v("\n      "+_vm._s(_vm.item && _vm.item.score ? _vm.item.score + "s" : "")+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"rank-top-name"},[_vm._v("\n      "+_vm._s(_vm.item && _vm.item.user && _vm.item.user.nickname ? _vm.item.user.nickname : "")+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f717368e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maze/rankItemTop.vue
// module id = null
// module chunks = 